var map = {
	"./ad.png": 56394,
	"./ae.png": 9638,
	"./af.png": 82191,
	"./afg.png": 18227,
	"./ag.png": 21702,
	"./al.png": 13762,
	"./alb.png": 18493,
	"./alg.png": 53393,
	"./am.png": 37636,
	"./ao.png": 60946,
	"./at.png": 86813,
	"./au.png": 99912,
	"./az.png": 45325,
	"./ba.png": 36246,
	"./bb.png": 5123,
	"./bd.png": 83571,
	"./be.png": 2567,
	"./bf.png": 42773,
	"./bg.png": 89465,
	"./bh.png": 85271,
	"./bi.png": 15157,
	"./bj.png": 14994,
	"./bn.png": 60217,
	"./bo.png": 77667,
	"./boh.png": 58573,
	"./bot.png": 81013,
	"./br.png": 84373,
	"./bs.png": 53826,
	"./bt.png": 51264,
	"./bw.png": 11043,
	"./by.png": 56106,
	"./bz.png": 68939,
	"./ca.png": 91433,
	"./cd.png": 41294,
	"./cf.png": 80338,
	"./cg.png": 91209,
	"./ch.png": 75415,
	"./ci.png": 78720,
	"./ck.png": 15091,
	"./cl.png": 29808,
	"./clb.png": 50532,
	"./cm.png": 39100,
	"./cn.png": 64949,
	"./cpe.png": 20129,
	"./cr.png": 15280,
	"./cu.png": 68058,
	"./cub.png": 30185,
	"./cv.png": 53035,
	"./cy.png": 31934,
	"./cz.png": 78755,
	"./de.png": 77505,
	"./dj.png": 29283,
	"./dk.png": 3327,
	"./dm.png": 76971,
	"./do.png": 29580,
	"./dz.png": 17468,
	"./ec.png": 22233,
	"./ee.png": 34078,
	"./eg.png": 89464,
	"./egy.png": 24498,
	"./eh.png": 10881,
	"./er.png": 48868,
	"./es.png": 46500,
	"./et.png": 5384,
	"./fg.png": 85354,
	"./fm.png": 50995,
	"./fn.png": 28478,
	"./fr.png": 41699,
	"./ga.png": 51449,
	"./gd.png": 58731,
	"./ge.png": 88995,
	"./gh.png": 97950,
	"./gha.png": 88603,
	"./gm.png": 96858,
	"./gn.png": 71033,
	"./gq.png": 8783,
	"./gr.png": 29852,
	"./gre.png": 47905,
	"./gt.png": 70355,
	"./gw.png": 8786,
	"./gy.png": 3082,
	"./hk.png": 79406,
	"./hn.png": 75141,
	"./hr.png": 82526,
	"./ht.png": 75013,
	"./hu.png": 96190,
	"./id.png": 40840,
	"./ie.png": 75096,
	"./il.png": 65534,
	"./in.png": 57131,
	"./iq.png": 82593,
	"./ir.png": 94637,
	"./is.png": 83979,
	"./it.png": 22984,
	"./jm.png": 9756,
	"./jmc.png": 37599,
	"./jo.png": 27752,
	"./jp.png": 77580,
	"./kg.png": 97270,
	"./kh.png": 38852,
	"./ki.png": 88310,
	"./km.png": 74784,
	"./kn.png": 61401,
	"./ko.png": 86270,
	"./kp.png": 24377,
	"./kw.png": 23205,
	"./ky.png": 64973,
	"./kyg.png": 48402,
	"./kz.png": 44862,
	"./kzk.png": 20903,
	"./la.png": 44734,
	"./lb.png": 50660,
	"./lbn.png": 74488,
	"./lc.png": 63063,
	"./li.png": 81258,
	"./lr.png": 67587,
	"./ls.png": 64285,
	"./lt.png": 98430,
	"./lu.png": 71370,
	"./lv.png": 2074,
	"./ly.png": 95062,
	"./mc.png": 56577,
	"./md.png": 67401,
	"./me.png": 68110,
	"./mg.png": 10121,
	"./mh.png": 42514,
	"./mk.png": 15705,
	"./ml.png": 91508,
	"./mm.png": 36692,
	"./mn.png": 25655,
	"./mo.png": 55366,
	"./mr.png": 81083,
	"./ms.png": 45927,
	"./mt.png": 60877,
	"./mu.png": 86798,
	"./mv.png": 36995,
	"./mw.png": 72079,
	"./mx.png": 45246,
	"./mz.png": 95761,
	"./na.png": 55022,
	"./ne.png": 38341,
	"./ng.png": 65630,
	"./ni.png": 78997,
	"./nmb.png": 94336,
	"./no.png": 5993,
	"./np.png": 54565,
	"./npl.png": 21469,
	"./nr.png": 18152,
	"./nt.png": 57457,
	"./nth.png": 91162,
	"./nu.png": 90547,
	"./nz.png": 21049,
	"./om.png": 3933,
	"./pa.png": 36001,
	"./pe.png": 26835,
	"./pg.png": 8515,
	"./ph.png": 50180,
	"./pk.png": 15986,
	"./pl Poland.png": 46544,
	"./pld.png": 54438,
	"./png.png": 31948,
	"./ps.png": 21670,
	"./pt.png": 7716,
	"./pw.png": 99359,
	"./py.png": 56582,
	"./qa.png": 22795,
	"./ro.png": 58785,
	"./rs.png": 6759,
	"./ru.png": 3784,
	"./rw.png": 10440,
	"./sa.png": 38375,
	"./sb.png": 10721,
	"./sc.png": 49122,
	"./scl.png": 28044,
	"./sd.png": 65914,
	"./sg.png": 96904,
	"./si.png": 58031,
	"./sk.png": 42401,
	"./sl.png": 17852,
	"./sm.png": 55960,
	"./sn.png": 45723,
	"./so.png": 62234,
	"./sp.png": 31216,
	"./sr.png": 53716,
	"./ss.png": 86770,
	"./st.png": 52757,
	"./sv.png": 29471,
	"./sw.png": 58533,
	"./sy.png": 71651,
	"./sz.png": 1799,
	"./td.png": 87820,
	"./tg.png": 46916,
	"./th.png": 9429,
	"./tj.png": 22534,
	"./tl.png": 18916,
	"./tm.png": 60477,
	"./tn.png": 162,
	"./tnu.png": 17401,
	"./to.png": 66746,
	"./tr.png": 66036,
	"./tt.png": 58760,
	"./tur.png": 64351,
	"./tv.png": 56974,
	"./tw.png": 1515,
	"./tz.png": 19311,
	"./ua.png": 70322,
	"./uae.png": 14123,
	"./ug.png": 96188,
	"./ugd.png": 71310,
	"./ukr.png": 23824,
	"./uru.png": 6790,
	"./usa.png": 2697,
	"./uy.png": 10274,
	"./uz.png": 20189,
	"./va.png": 16879,
	"./vc.png": 66502,
	"./ve.png": 20799,
	"./vnz.png": 63433,
	"./vt.png": 63362,
	"./vu.png": 30255,
	"./ws.png": 12021,
	"./xk.png": 6721,
	"./ye.png": 10678,
	"./zm.png": 34846,
	"./zw.png": 93647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19742;